<template>
  <div id="about-me-index">
    <section id="intro">
      <div id="intro__background"></div>
      <br><br>
      <h1 class="text-center">{{config.APP_NAME}}</h1>
      <h4 class="text-center">Một sản phẩm của Socola trong quá trình tìm hiểu <strong>Laravel</strong> (<strong>RESTful APIs</strong>, <strong>LaravelApi</strong>), <strong>VueJS</strong> (<strong>SPA</strong>), <strong>Service Workers</strong>.</h4>
    </section>
    <div class="container">
      <section>
        <h2 class="text-center">Giới thiệu</h2>
        <hr class="devider devider-2x">
        <br>
        <p class="text-center">Đến với Socola Movie bạn sẽ được thưởng thức những bộ phim mới nhất, hay nhất một cách nhanh nhất.</p>
      </section>
      <section>
        <h2 class="text-center">Thiết bị hỗ trợ</h2>
        <hr class="devider devider-2x">
        <p class="text-center">Hoạt động ổn định trên nhiều loại thiết bị như Desktop, Laptop, tablet, smart phone.</p>
        <br>
        <div class="row">
          <div class="col-xs-12 col-sm-6 col-md-4 col-lg-2" v-for="device in devices" :key="device.name">
            <div class="text-center">
              <i :class="['fa fa-2x fa-cicle', device.icon]"></i>
              <br>
              <br>
              <h4><b>{{device.name}}</b></h4>
              <br>
              <!-- <hr class="devider devider-1x">             -->
            </div>
          </div>
        </div>
      </section>
      <section>
        <h2 class="text-center">Kiến thức học được</h2>
        <hr class="devider devider-2x">
        <br>
        <div class="clearfix">
          <div class="col-xs-12 col-sm-4 col-md-3 col-lg-3" v-for="(service, i) in services" :key="i">
            <div class="text-center">
              <i :class="['fa fa-2x fa-cicle', service.icon || 'fa-file-movie-o']"></i>
              <br><br>
              <h4><b>{{service.title || 'Lorem ipsum.'}}</b></h4>
              <hr class="devider devider-1x">
              <p class="text-justify"><span v-html="service.description || 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Incidunt nam distinctio vero in neque possimus dolores. Ducimus harum deleniti, facilis!'"></span></p>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
export default {
  name: 'about-us-index',
  data() {
    return {
      devices: [
        { name: 'Desktop', icon: 'fa-desktop' },
        { name: 'Laptop', icon: 'fa-laptop' },
        { name: 'Tablet', icon: 'fa-tablet' },
        { name: 'Smart phone', icon: 'fa-mobile' },
        { name: 'Android', icon: 'fa fa-android' },
        { name: 'IOS', icon: 'fa fa-apple' },
      ],
      services: [{
        title: 'VueJS',
        icon: 'fa-laptop',
        description: 'Sử dụng công nghệ <strong>SPA</strong> (Single Page Application), <strong>i18n</strong> (Multiple Languages)'
      }, {
        title: 'Laravel',
        icon: 'fa-mobile fa-3x',
        description: 'Xây dựng mô hình client-server trong đó laravel đóng vai trò là <strong>RESTful APIs</strong>',
      }, {
        title: 'Laravel Api',
        icon: 'fa-server',
        description: 'Trong quá trình thực hiện project mình có xây dựng một package đó là <a href="https://github.com/socolaDaiCa/laravel-api" title="Laravel Api" target="_blank" rel="noopener noreferrer"><strong>LaravelApi</strong></a>. Nó giúp mình tiết kiệm thời gian khi viết Api CRUD.'
      }, {
        title: 'PWA',
        icon: 'fa-font-awesome',
        description: '<strong>Progressive Web Apps</strong>, với sự giúp đỡ của <a href="https://developers.google.com/web/fundamentals/primers/service-workers/" title="Service Workers"></a><strong>Service Workers</strong> chúng ta đã có thể xoá nhoà khoảng cách giữa web app và native app.',
      }],
    }
  },
  metaInfo() {
    return {
      title: this.$t("About Me"),
    };
  }
}

</script>
